import styled from '@emotion/styled'

const AvoidWrap = styled.span({
	display: 'inline-block',
})

export default AvoidWrap
